module.exports = __webpack_public_path__ + "img/TRP.b3f1975a.png";